export const SESSION_STORAGE_KEYS = {
  USER_MOBILE: 'payufin_user_mobile',
  MASTER_USER_ID: 'payufin_master_user_id',
  AUTH_FROM_URL: 'payufin_auth_from_url'
}
